<template>

  <label :title="title" style="padding: 0.375rem 0.5rem !important;" :class="{ toggleSwitch : !notToggle, toggleOn : internalValue, disabled : disabled, 'text-muted' : disabled }">
    <input v-bind:for="id" type="checkbox" v-model="internalValue" style="margin-right: 0.1rem;" :disabled="disabled">
    {{label}}
  </label>

</template>

<script>

  export default {
    name: 'input-checkbox',
    props: {
      'label': {type: String, required: true},
      'inputId': {type: String},
      'title': {type: String},
      'notToggle': {type: String},
      // we need to define prop value to hook into v-model (SET [v-model] ON COMPONENT INCLUSION AS NORMAL)
	  'value': {},
	  'disabled': { type: Boolean }
    },
    created: function () {
      // We initially sync the internalValue with the value passed in by the parent
      this.internalValue = this.value;
      this.id = this.inputId || ("aw-input-checkbox-" + this._uid);
    },
    mounted: function () {
      if (this.title)
        $(this.$el).tooltip({trigger: 'hover', html: true});
    },
    data: function () {
      return {
        internalValue: false,
        id: null,
      }
    },
    watch: {
      internalValue: function () {
        // we need to emit input to hook into v-model
        this.$emit('input', this.internalValue);
        this.$emit('onChanged', this.internalValue);
      },
      // Listen back to the original value from the outside!
      value: function () {
        this.internalValue = this.value;
      }
    }
  }
</script>

<style scoped>
	label.toggleSwitch {
		border: 1px solid #ccc;
		border-radius: 5px;
		display: block;
	}

	label.toggleSwitch.disabled
	{
		border-color: #ced4da !important;
		background-color: #f5f7fa !important;
	}

	label.toggleSwitch.disabled.toggleOn {
		border-color: #ced4da !important;
		background-color: #e9ecef !important;
	}

	label.toggleSwitch.toggleOn {
		background-color: rgb(245, 227, 215);
		border-color: rgb(226, 165, 116);
		/* font-weight: bold; */
	}
</style>



// WEBPACK FOOTER //
// src/components/utilities/InputCheckbox.vue